/* eslint-disable no-unused-vars */
import { MenuItem, Button } from '@material-ui/core';
import React, { forwardRef, useImperativeHandle, useState, useEffect, } from 'react';
import { DuoColumnSelector } from '../../../../../commons/DuoColumnSelector';
import { TopLabeledTextField } from '../../../../../commons/TopLabeledTextField';
import { CustomHelperText } from '../../Sequence.Styles';
import { TextWrapper, Wrapper } from './BasicConfig.Styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
var basicConfig = function (props, ref) {
    var _a = useState('none'), livePartyHandler = _a[0], setLivePartyHandler = _a[1];
    var _b = useState('none'), livePartyContactFlow = _b[0], setLivePartyContactFlow = _b[1];
    var _c = useState('none'), answeringMachineHandler = _c[0], setAnsweringMachineHandler = _c[1];
    var _d = useState('none'), answeringMachineContactFlow = _d[0], setAnsweringMachineContactFlow = _d[1];
    var _e = useState([]), phones = _e[0], setPhones = _e[1];
    var _f = useState(false), phonesTouched = _f[0], setPhonesTouched = _f[1];
    var _g = useState(false), livePartyHandlerTouched = _g[0], setLivePartyHandlerTouched = _g[1];
    var _h = useState(false), livePartyContactFlowTouched = _h[0], setLivePartyContactFlowTouched = _h[1];
    var _j = useState(false), answeringMachineHandlerTouched = _j[0], setAnsweringMachineHandlerTouched = _j[1];
    var _k = useState(false), answeringMachineContactFlowTouched = _k[0], setAnsweringMachineContactFlowTouched = _k[1];
    var _l = useState([]), validatedStudioFlows = _l[0], setValidatedStudioFlows = _l[1];
    var _m = useState([]), phoneTypes = _m[0], setPhoneTypes = _m[1];
    var _o = useState(false), openLiveAlert = _o[0], setOpenLiveAlert = _o[1];
    var _p = useState(false), openAnswerAlert = _p[0], setOpenAnswerAlert = _p[1];
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g;
        var campaign = props === null || props === void 0 ? void 0 : props.campaign;
        if ((_a = campaign === null || campaign === void 0 ? void 0 : campaign.BaseConfig) === null || _a === void 0 ? void 0 : _a.ActivePhoneTypes) {
            setPhones([]);
            setPhoneTypes((_b = campaign === null || campaign === void 0 ? void 0 : campaign.BaseConfig) === null || _b === void 0 ? void 0 : _b.ActivePhoneTypes);
        }
        else
            setPhoneTypes([]);
        // if a studio flow, filter out the override in the list of options
        if (((_c = campaign === null || campaign === void 0 ? void 0 : campaign.BaseConfig) === null || _c === void 0 ? void 0 : _c.ContactFlowOverride) != null &&
            ((_d = campaign === null || campaign === void 0 ? void 0 : campaign.BaseConfig) === null || _d === void 0 ? void 0 : _d.ContactFlowOverride) !== '') {
            var validatedStudioFlowsTemp = ((_e = props === null || props === void 0 ? void 0 : props.studioFlows) === null || _e === void 0 ? void 0 : _e.filter(function (sf) { return sf.Id !== campaign.BaseConfig.ContactFlowOverride; })) || [];
            setValidatedStudioFlows(validatedStudioFlowsTemp);
        }
        else {
            // otherwise, filter out the global from the listo of options
            if ((_f = props.dialerDefaults) === null || _f === void 0 ? void 0 : _f.StudioFlowSid) {
                var validatedStudioFlowsTemp = ((_g = props === null || props === void 0 ? void 0 : props.studioFlows) === null || _g === void 0 ? void 0 : _g.filter(function (sf) { return sf.Id !== props.dialerDefaults.StudioFlowSid; })) || [];
                setValidatedStudioFlows(validatedStudioFlowsTemp);
            }
        }
    }, [props.campaign]);
    useImperativeHandle(ref, function () { return ({
        getValues: function () {
            setPhonesTouched(true);
            setLivePartyHandlerTouched(true);
            setAnsweringMachineHandlerTouched(true);
            setLivePartyContactFlowTouched(livePartyHandler === 'PASS_TO_CONTACT_FLOW');
            setAnsweringMachineContactFlowTouched(answeringMachineHandler === 'PASS_TO_CONTACT_FLOW');
            return {
                livePartyHandler: livePartyHandler,
                livePartyContactFlow: livePartyContactFlow,
                answeringMachineHandler: answeringMachineHandler,
                answeringMachineContactFlow: answeringMachineContactFlow,
                phones: phones
            };
        },
        reSet: function () {
            setPhonesTouched(false);
            setLivePartyHandlerTouched(false);
            setLivePartyContactFlowTouched(false);
            setAnsweringMachineHandlerTouched(false);
            setAnsweringMachineContactFlowTouched(false);
            setLivePartyHandler('none');
            setLivePartyContactFlow('none');
            setAnsweringMachineHandler('none');
            setAnsweringMachineContactFlow('none');
            setPhones([]);
        },
        setData: function (data) {
            setLivePartyHandler(data.livePartyHandler);
            setLivePartyContactFlow(data.livePartyContactFlow);
            setAnsweringMachineHandler(data.answeringMachineHandler);
            setAnsweringMachineContactFlow(data.answeringMachineContactFlow);
            setPhones(data.phones);
        }
    }); });
    var livePartyContactFlowComponent = (React.createElement(TopLabeledTextField, { name: 'livePartyContactFlow', label: 'Live Party Contact Flow', select: true, fullWidth: true, value: livePartyContactFlow, onChange: function (e) { return setLivePartyContactFlow(e.target.value); }, onBlur: function () { return setLivePartyContactFlowTouched(true); }, error: livePartyContactFlow === 'none' && livePartyContactFlowTouched, helperText: livePartyContactFlow === 'none' &&
            livePartyContactFlowTouched &&
            'This Field is Required' },
        React.createElement(MenuItem, { value: 'none', disabled: true }, "Please Select"),
        validatedStudioFlows.length > 0 ? (validatedStudioFlows.map(function (_a) {
            var Id = _a.Id, Name = _a.Name;
            return (React.createElement(MenuItem, { key: Id, value: Id },
                Name !== null && Name !== undefined ? Name + ' - ' : null,
                " ",
                Id));
        })) : (React.createElement(MenuItem, { disabled: true }, "Please select a campaign"))));
    var answeringMachineContactFlowComponent = (React.createElement(TopLabeledTextField, { name: 'answeringMachineContactFlow', label: 'Answering Machine Studio Flow', select: true, fullWidth: true, value: answeringMachineContactFlow, onChange: function (e) { return setAnsweringMachineContactFlow(e.target.value); }, onBlur: function () { return setAnsweringMachineContactFlowTouched(true); }, error: answeringMachineContactFlow === 'none' &&
            answeringMachineContactFlowTouched, helperText: answeringMachineContactFlow === 'none' &&
            answeringMachineContactFlowTouched &&
            'This Field is Required' },
        React.createElement(MenuItem, { value: 'none', disabled: true }, "Please Select"),
        validatedStudioFlows.length > 0
            ? validatedStudioFlows.map(function (_a) {
                var Id = _a.Id, Name = _a.Name;
                return (React.createElement(MenuItem, { key: Id, value: Id },
                    Name !== null && Name !== undefined ? Name + ' - ' : null,
                    ' ',
                    Id));
            })
            : null));
    var handleAlert = function (mode) {
        if (mode === 'live') {
            setOpenLiveAlert(true);
        }
        if (mode === 'answer') {
            setOpenAnswerAlert(true);
        }
    };
    var handleCloseAlert = function (mode) {
        if (mode === 'live') {
            setOpenLiveAlert(false);
        }
        if (mode === 'answer') {
            setOpenAnswerAlert(false);
        }
    };
    return (React.createElement(Wrapper, null,
        React.createElement(TextWrapper, null,
            React.createElement(TopLabeledTextField, { name: 'livePartyHandler', label: 'Live Party Handler', select: true, fullWidth: true, value: livePartyHandler, onChange: function (e) {
                    setLivePartyHandler(e.target.value);
                    if (e.target.value === 'PASS_TO_CONTACT_FLOW')
                        props.handleBasicConfigHandlers('liveParty', true);
                    else
                        props.handleBasicConfigHandlers('liveParty', false);
                }, onBlur: function () { return setLivePartyHandlerTouched(true); }, error: livePartyHandler === 'none' && livePartyHandlerTouched, helperText: livePartyHandler === 'none' &&
                    livePartyHandlerTouched &&
                    'This Field is Required' },
                React.createElement(MenuItem, { value: 'none', disabled: true }, "Please Select"),
                React.createElement(MenuItem, { value: 'PASS_TO_AGENT' }, "Agent"),
                React.createElement(MenuItem, { onClick: function () { return handleAlert('live'); }, value: 'HANG_UP' }, "Hang Up"),
                React.createElement(MenuItem, { value: 'PASS_TO_CONTACT_FLOW' }, "Contact Flow")),
            livePartyHandler === 'PASS_TO_CONTACT_FLOW'
                ? livePartyContactFlowComponent
                : null,
            React.createElement(Dialog, { open: openLiveAlert, onClose: handleCloseAlert },
                React.createElement(DialogTitle, { id: 'hangUp-warning' }, "Live Party Warning"),
                React.createElement(DialogContent, null,
                    React.createElement(DialogContentText, { id: 'hangUp-description' }, "Be warned that selecting Hang Up will Hang Up on the Live Party Handler")),
                React.createElement(DialogActions, null,
                    React.createElement(Button, { onClick: function () { return handleCloseAlert('live'); }, color: 'primary' }, "Confirm")))),
        React.createElement(TextWrapper, null,
            React.createElement(TopLabeledTextField, { name: 'answeringMachineHandler', label: 'Answering Machine Handler', select: true, fullWidth: true, value: answeringMachineHandler, onChange: function (e) {
                    setAnsweringMachineHandler(e.target.value);
                    if (e.target.value === 'PASS_TO_CONTACT_FLOW')
                        props.handleBasicConfigHandlers('answeringMachine', true);
                    else
                        props.handleBasicConfigHandlers('answeringMachine', false);
                }, onBlur: function () { return setAnsweringMachineHandlerTouched(true); }, error: answeringMachineHandler === 'none' && answeringMachineHandlerTouched, helperText: answeringMachineHandler === 'none' &&
                    answeringMachineHandlerTouched &&
                    'This Field is Required' },
                React.createElement(MenuItem, { value: 'none', disabled: true }, "Please Select"),
                React.createElement(MenuItem, { value: 'PASS_TO_AGENT' }, "Agent"),
                React.createElement(MenuItem, { onClick: function () { return handleAlert('answer'); }, value: 'HANG_UP' }, "Hang Up"),
                React.createElement(MenuItem, { value: 'PASS_TO_CONTACT_FLOW' }, "Contact Flow")),
            answeringMachineHandler === 'PASS_TO_CONTACT_FLOW'
                ? answeringMachineContactFlowComponent
                : null,
            React.createElement(Dialog, { open: openAnswerAlert, onClose: handleCloseAlert },
                React.createElement(DialogTitle, { id: 'hangUpAnswer-warning' }, "Answering Machine Warning"),
                React.createElement(DialogContent, null,
                    React.createElement(DialogContentText, { id: 'hangUpAnswer-description' }, "Be warned that selecting Hang Up will Hang Up on the Answering Machine Handler")),
                React.createElement(DialogActions, null,
                    React.createElement(Button, { onClick: function () { return handleCloseAlert('answer'); }, color: 'primary' }, "Confirm")))),
        React.createElement(React.Fragment, null,
            React.createElement(DuoColumnSelector, { name: 'phones', label: 'Phones', itemOptions: phoneTypes, dependency: phoneTypes, values: phones !== null && phones !== undefined ? phones : [], onChange: function (e) {
                    setPhones(e);
                    setPhonesTouched(true);
                } }),
            phones.length === 0 && phonesTouched && (React.createElement(CustomHelperText, { error: true }, "This Field is Required")))));
};
export var BasicConfig = forwardRef(basicConfig);
//# sourceMappingURL=BasicConfig.js.map